"use strict"

import scroller from "./controllers/scroller"
import head from "./controllers/head"
import masonry from "./controllers/masonry"
import reveal from "./controllers/reveal"
import slider from "./controllers/slider"
import scrollToTop from "./controllers/scroll-to-top"
import video from "./controllers/video"
import mparticle from "./controllers/mparticle"

const initializedControllers = new WeakSet()
const controllers = {
  scroller: scroller,
  head,
  mparticle,
  masonry,
  reveal,
  slider,
  "scroll-to-top": scrollToTop,
  video,
}

function init() {
  loadControllers()

  window.requestAnimationFrame(() => {
    document.documentElement.classList.add("is-ready")
  })

  konami()
}

function loadControllers(root) {
  root = root || document.documentElement

  Array.from(root.querySelectorAll("[data-controller]")).forEach(function (el) {
    const names = el.dataset.controller.split(",")

    names.forEach(function (name) {
      try {
        if (Object.hasOwnProperty.call(controllers, name)) {
          const mod = new controllers[name](el, el.dataset)
          initializedControllers.add(mod)
        } else {
          throw new Error(`Controller ${name} does not exist`)
        }
      } catch (err) {
        console.error(err)
      }
    })
  })
}

if (document.readyState !== "loading") {
  init()
} else {
  document.addEventListener(
    "DOMContentLoaded",
    function () {
      init()
    },
    true,
  )
}

function doit() {
  const elements = `<div class="Hello"><img src="https://10chambers.com/wp-content/themes/10chambers/assets/images/skull.png"/></div>`
  document.body.insertAdjacentHTML("beforeend", elements)
}

function konami() {
  var pressed = []
  var theSecretCode = [
    "ArrowUp",
    "ArrowUp",
    "ArrowDown",
    "ArrowDown",
    "ArrowLeft",
    "ArrowRight",
    "ArrowLeft",
    "ArrowRight",
    "b",
    "a",
  ]

  window.addEventListener("keydown", onKeydown, {
    passive: true,
  })

  function onKeydown(e) {
    if (theSecretCode.includes(e.key) === false) {
      pressed = []
      return
    }

    pressed.push(e.key)

    if (pressed.length > theSecretCode.length) {
      pressed.shift()
    }

    if (pressed.join(",") === theSecretCode.join(",")) {
      window.removeEventListener("keydown", onKeydown)
      doit()
    }
  }
}
